import { Pipe, PipeTransform } from '@angular/core';
import { fromUnixTime } from 'date-fns';
import { formatDate } from 'devextreme/localization';

@Pipe({
  name: 'integerDate',
  pure: false,
  standalone: true,
})
export class IntegerDatePipe implements PipeTransform {
  transform(number: number): string | undefined {
    const date = fromUnixTime(number);
    return formatDate(date, 'dd/MM/yyyy HH:mm:ss');
  }
}
